// "use client";

// import { usePathname, useRouter, useSearchParams } from "next/navigation";
// import { useMemo, useState } from "react";
// import { useCart } from "@/store/hooks";
// import {
//   ORDER_TYPE,
//   getProductOrderType,
// } from "@/lib/orderType";
// import { formatMoney, getVariantPrice, isVariantInStock } from "@/lib/format";
// import ProductQuickViewModal from "@/components/modal/ProductQuickViewModal";

// function productSize(product, variant) {
//   const metadataSize =
//     product?.metadata?.pack_size ||
//     product?.metadata?.size ||
//     product?.metadata?.weight;

//   if (typeof metadataSize === "string" && metadataSize.trim()) {
//     return metadataSize.trim();
//   }

//   if (variant?.title && !/^default( variant)?$/i.test(variant.title)) {
//     return variant.title;
//   }

//   return product?.subtitle || "";
// }

// function getProductImage(product) {
//   const variant = product?.variants?.[0];

//   if (variant?.images?.length) {
//     const image =
//       typeof variant.images[0] === "string"
//         ? variant.images[0]
//         : variant.images[0]?.url;
//     if (image) return image;
//   }

//   if (product?.thumbnail) return product.thumbnail;

//   if (product?.images?.length) {
//     const image =
//       typeof product.images[0] === "string"
//         ? product.images[0]
//         : product.images[0]?.url;
//     if (image) return image;
//   }

//   return "/assets/images/product-placeholder.png";
// }

// export default function ProductCard({ product, imageOverride, compact = false }) {
//   const variants = product?.variants || [];
//   const [variantId, setVariantId] = useState(
//     variants.find((item) => isVariantInStock(item))?.id || variants[0]?.id || "",
//   );
//   const [busy, setBusy] = useState(false);
//   const [message, setMessage] = useState("");

//   const orderType = getProductOrderType(product);
//   const cartApi = useCart(orderType || ORDER_TYPE.GROCERY);
//   const { cart, addToCart, updateItemQuantity, removeItem, region } = cartApi;

//   const router = useRouter();
//   const pathname = usePathname();
//   const searchParams = useSearchParams();
//   const [quickViewOpen, setQuickViewOpen] = useState(false);

//   const variant = useMemo(
//     () => variants.find((item) => item.id === variantId) || variants[0],
//     [variants, variantId],
//   );

//   const lineItem = useMemo(
//     () =>
//       (cart?.items || []).find(
//         (item) =>
//           item.variant_id === variant?.id || item.variant?.id === variant?.id,
//       ),
//     [cart?.items, variant?.id],
//   );

//   const quantity = lineItem?.quantity || 0;
//   const inStock = isVariantInStock(variant);
//   const price = getVariantPrice(variant);
//   const currency =
//     variant?.calculated_price?.currency_code || region?.currency_code || "cad";

//   const productImage = imageOverride || getProductImage(product);

//   async function changeQuantity(delta) {
//     if (!variant || busy) return;

//     if (!orderType) {
//       setMessage("Product Type must be Grocery or Prepared Food in Medusa.");
//       return;
//     }

//     setBusy(true);
//     setMessage("");

//     try {
//       if (!lineItem && delta > 0) {
//         await addToCart(variant.id, 1);
//       } else if (lineItem) {
//         const next = quantity + delta;
//         if (next <= 0) await removeItem(lineItem.id);
//         else await updateItemQuantity(lineItem.id, next);
//       }
//     } catch (error) {
//       setMessage(error?.message || "Unable to update basket.");
//       window.setTimeout(() => setMessage(""), 2500);
//     } finally {
//       setBusy(false);
//     }
//   }

//   if (!product) return null;

//   function openProductModal() {
//     const params = new URLSearchParams(searchParams.toString());
//     params.set("product", product.handle || product.id);

//     router.replace(`${pathname}?${params.toString()}`, { scroll: false });
//     setQuickViewOpen(true);
//   }

//   function closeProductModal() {
//     setQuickViewOpen(false);

//     const params = new URLSearchParams(searchParams.toString());
//     params.delete("product");
//     const queryString = params.toString();

//     router.replace(queryString ? `${pathname}?${queryString}` : pathname, {
//       scroll: false,
//     });
//   }

//   return (
//     <>
//       <ProductQuickViewModal
//         product={product}
//         imageOverride={imageOverride}
//         open={quickViewOpen}
//         onClose={closeProductModal}
//       />

//       <article
//         className={`asian-bucket-product-card ${compact ? "is-compact" : ""} ${
//           !inStock ? "is-out" : ""
//         }`}
//       >
//         <div className="asian-bucket-product-image-main-wrapper">
//           <div
//             className="asian-bucket-product-image-link"
//             onClick={openProductModal}
//           >
//             {productImage ? (
//               <img src={productImage} alt={product.title} />
//             ) : (
//               <div className="asian-bucket-product-placeholder">Asian Basket</div>
//             )}
//           </div>

//           {!inStock && (
//             <span className="asian-bucket-product-out-badge">Out of stock</span>
//           )}

//           <div
//             className={`asian-bucket-product-quantity-main-wrapper ${
//               quantity ? "has-quantity" : ""
//             }`}
//             aria-label={`Quantity of ${product.title} in basket`}
//           >
//             {quantity > 0 && (
//               <button
//                 type="button"
//                 disabled={busy}
//                 onClick={() => changeQuantity(-1)}
//                 aria-label={`Remove one ${product.title}`}
//               >
//                 <img src="/assets/icons/minus.svg" alt="" />
//               </button>
//             )}

//             {quantity > 0 && <span>{quantity}</span>}

//             <button
//               type="button"
//               disabled={!inStock || busy}
//               onClick={() => changeQuantity(1)}
//               aria-label={`Add one ${product.title}`}
//             >
//               <img src="/assets/icons/plus.svg" alt="" />
//             </button>
//           </div>
//         </div>

//         <div className="asian-bucket-product-content-main-wrapper">
//           <h3 onClick={openProductModal}>{product.title}</h3>

//           <p className="asian-bucket-product-price">
//             {price !== null ? formatMoney(price, currency) : "Price unavailable"}
//           </p>

//           {productSize(product, variant) && (
//             <p className="asian-bucket-product-size">
//               {productSize(product, variant)}
//             </p>
//           )}

//           {message && <p className="asian-bucket-product-error">{message}</p>}
//         </div>
//       </article>
//     </>
//   );
// }

"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useMemo, useState } from "react";
import { useCart } from "@/store/hooks";
import { ORDER_TYPE, getProductOrderType } from "@/lib/orderType";
import {
  formatMoney,
  getVariantPriceData,
  getSaleBadgeLabel,
  isVariantInStock,
} from "@/lib/format";
import ProductQuickViewModal from "@/components/modal/ProductQuickViewModal";

function productSize(product, variant) {
  const metadataSize =
    product?.metadata?.pack_size ||
    product?.metadata?.size ||
    product?.metadata?.weight;

  if (typeof metadataSize === "string" && metadataSize.trim()) {
    return metadataSize.trim();
  }

  if (variant?.title && !/^default( variant)?$/i.test(variant.title)) {
    return variant.title;
  }

  return product?.subtitle || "";
}

function getProductImage(product) {
  const variant = product?.variants?.[0];

  if (variant?.images?.length) {
    const image =
      typeof variant.images[0] === "string"
        ? variant.images[0]
        : variant.images[0]?.url;
    if (image) return image;
  }

  if (product?.thumbnail) return product.thumbnail;

  if (product?.images?.length) {
    const image =
      typeof product.images[0] === "string"
        ? product.images[0]
        : product.images[0]?.url;
    if (image) return image;
  }

  return "/assets/images/product-placeholder.png";
}

export default function ProductCard({
  product,
  imageOverride,
  compact = false,
}) {
  const variants = product?.variants || [];
  const [variantId, setVariantId] = useState(
    variants.find((item) => isVariantInStock(item))?.id ||
      variants[0]?.id ||
      "",
  );
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const orderType = getProductOrderType(product);
  const cartApi = useCart(orderType || ORDER_TYPE.GROCERY);
  const { cart, addToCart, updateItemQuantity, removeItem } = cartApi;

  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [quickViewOpen, setQuickViewOpen] = useState(false);

  const variant = useMemo(
    () => variants.find((item) => item.id === variantId) || variants[0],
    [variants, variantId],
  );

  const lineItem = useMemo(
    () =>
      (cart?.items || []).find(
        (item) =>
          item.variant_id === variant?.id || item.variant?.id === variant?.id,
      ),
    [cart?.items, variant?.id],
  );

  const quantity = lineItem?.quantity || 0;
  const inStock = isVariantInStock(variant);
  const priceData = getVariantPriceData(variant);
  const productImage = imageOverride || getProductImage(product);

  async function changeQuantity(delta) {
    if (!variant || busy) return;

    if (!orderType) {
      setMessage("Product Type must be Grocery or Prepared Food in Medusa.");
      return;
    }

    setBusy(true);
    setMessage("");

    try {
      if (!lineItem && delta > 0) {
        await addToCart(variant.id, 1);
      } else if (lineItem) {
        const next = quantity + delta;
        if (next <= 0) await removeItem(lineItem.id);
        else await updateItemQuantity(lineItem.id, next);
      }
    } catch (error) {
      setMessage(error?.message || "Unable to update basket.");
      window.setTimeout(() => setMessage(""), 2500);
    } finally {
      setBusy(false);
    }
  }

  if (!product) return null;

  function openProductModal() {
    const params = new URLSearchParams(searchParams.toString());
    params.set("product", product.handle || product.id);

    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
    setQuickViewOpen(true);
  }

  function closeProductModal() {
    setQuickViewOpen(false);

    const params = new URLSearchParams(searchParams.toString());
    params.delete("product");
    const queryString = params.toString();

    router.replace(queryString ? `${pathname}?${queryString}` : pathname, {
      scroll: false,
    });
  }

  return (
    <>
      <ProductQuickViewModal
        product={product}
        imageOverride={imageOverride}
        open={quickViewOpen}
        onClose={closeProductModal}
      />

      <article
        className={`asian-bucket-product-card ${compact ? "is-compact" : ""} ${
          !inStock ? "is-out" : ""
        } ${priceData.isOnSale ? "has-sale" : ""}`}
      >
        <div className="asian-bucket-product-image-main-wrapper">
          <div
            className="asian-bucket-product-image-link"
            onClick={openProductModal}
          >
            {productImage ? (
              <img src={productImage} alt={product.title} />
            ) : (
              <div className="asian-bucket-product-placeholder">
                Asian Basket
              </div>
            )}
          </div>

          {priceData.isOnSale && (
            <span className="asian-bucket-product-sale-badge">
              {getSaleBadgeLabel(priceData)}
            </span>
          )}

          {!inStock && (
            <span className="asian-bucket-product-out-badge">Out of stock</span>
          )}

          <div
            className={`asian-bucket-product-quantity-main-wrapper ${
              quantity ? "has-quantity" : ""
            }`}
            aria-label={`Quantity of ${product.title} in basket`}
          >
            {quantity > 0 && (
              <button
                type="button"
                disabled={busy}
                onClick={() => changeQuantity(-1)}
                aria-label={`Remove one ${product.title}`}
              >
                <img src="/assets/icons/minus.svg" alt="" />
              </button>
            )}

            {quantity > 0 && <span>{quantity}</span>}

            <button
              type="button"
              disabled={!inStock || busy}
              onClick={() => changeQuantity(1)}
              aria-label={`Add one ${product.title}`}
            >
              <img src="/assets/icons/plus.svg" alt="" />
            </button>
          </div>
        </div>

        <div className="asian-bucket-product-content-main-wrapper">
          <h3 onClick={openProductModal}>{product.title}</h3>

          {priceData.current !== null ? (
            priceData.isOnSale ? (
              <div className="asian-bucket-product-price-row">
                <span className="asian-bucket-product-original-price">
                  {formatMoney(priceData.original, priceData.currency)}
                </span>
                <span className="asian-bucket-product-sale-price">
                  {formatMoney(priceData.current, priceData.currency)}
                </span>
              </div>
            ) : (
              <p className="asian-bucket-product-price">
                {formatMoney(priceData.current, priceData.currency)}
              </p>
            )
          ) : (
            <p className="asian-bucket-product-price">Price unavailable</p>
          )}

          {productSize(product, variant) && (
            <p className="asian-bucket-product-size">
              {productSize(product, variant)}
            </p>
          )}

          {message && <p className="asian-bucket-product-error">{message}</p>}
        </div>
      </article>
    </>
  );
}
